// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2VGjS","select":"Header_select__ILApQ","clinic":"Header_clinic__2GfPs"};